import { IconClose } from 'assets/icons';
import ModalContainer from 'containers/ProductRegist/components/common/ModalContainer';
import { PropsWithChildren } from 'react';
import styled from 'styled-components';

const ModalHeader = styled.header<{ $isMobile: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;

  position: sticky;
  top: 0;
  left: 0;
  right: 0;

  /* margin-top: ${({ $isMobile }) => ($isMobile ? '24px' : '0px')}; */
  padding: ${({ $isMobile }) => ($isMobile ? '36px 20px 24px' : '32px 20px')};

  background-color: white;

  > h6 {
    margin: 0;

    font-size: 20px;
    color: rgba(27, 28, 30, 1);
    font-weight: 600;
    line-height: 28px;
  }
`;

interface Props extends PropsWithChildren {
  isMobile: boolean;
  handleModal: () => void;
  useCustomHeader?: boolean;
  headerTitle?: string;
  // handleSelectingMonth: (value: Option) => void;
  style?: React.CSSProperties;
  onClickBackground?: () => void;
}

function ModalBase({
  children,
  isMobile,
  handleModal,
  useCustomHeader = false,
  headerTitle,
  onClickBackground,
  style = {},
}: Props) {
  return (
    <ModalContainer
      isMobile={isMobile}
      isAbled={true}
      onClickBackground={onClickBackground}
      onClick={() => {}}
      onClose={() => {}}
      isBottomSheet
      style={{ gap: 0, ...style }}
    >
      <>
        {!useCustomHeader ? (
          <ModalHeader $isMobile={isMobile}>
            {headerTitle && <h6>{headerTitle}</h6>}

            <IconClose color="rgba(112, 115, 124, 1)" onClick={handleModal} />
          </ModalHeader>
        ) : (
          <></>
        )}

        {children}
      </>
    </ModalContainer>
  );
}

export default ModalBase;
